module.exports = __webpack_public_path__ + "static/media/weedmaps-logo-white.6ca87239.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weedmaps-logo-white.svg
// module id = 2438
// module chunks = 0